import { IAttachmentHolder, Attachment, RenderObject } from "./RenderObject";
import { SceneNode, Scene } from "@spi/Common/Collada";
import { mat4 } from "gl-matrix";

export class ColladaAttachmentHolder implements IAttachmentHolder {

    private jointAttachments: Map<SceneNode, Attachment>;

    constructor(public parent: RenderObject, public visualScene: Scene) {
        this.jointAttachments = new Map();
    }

    setAttachment(attachPoint: string, obj: RenderObject): Attachment {

        let attachment = new Attachment(attachPoint, obj, this.parent);

        let node = this.visualScene.lookupNode(attachPoint);
        if (!node) {
            throw new Error(`Attempted to attach object to bone ${attachPoint} but such a bone does not exist.`);
        }

        obj.attachmentIdentity = attachment;

        this.jointAttachments.set(node, attachment);

        return attachment;
    }

    getAttachment(attachPoint: string): Attachment {
        let node = this.visualScene.lookupNode(attachPoint);
        if (node) {
            if (this.jointAttachments.has(node)) {
                return this.jointAttachments.get(node);
            }
        }

        return null;
    }

    clearAttachment(attachPoint: string): Attachment {
        let node = this.visualScene.lookupNode(attachPoint);
        if (node) {
            if (this.jointAttachments.has(node)) {
                let attachment = this.jointAttachments.get(node);
                this.jointAttachments.delete(node);

                attachment.object.attachmentIdentity = null;
                return attachment;
            }
        }

        return null;
    }

    preRenderAttachments(modelViewMatrix: mat4): void {
        if (!this.parent.isAnimated) {
            return;
        }

        let frameSet = this.parent.animationState.getFrames();

        this.jointAttachments.forEach((attachment, node) => {
            let m = mat4.clone(modelViewMatrix);
            mat4.scale(m, m, this.parent.scale);

            let offsetMatrix = mat4.create();
            // TODO: Add offset/rotation specific to attachment
            let boneMat = mat4.clone(frameSet.frames[node.reference].jointMatrix);

            attachment.modelViewMatrix = m;
            attachment.boneMatrix = boneMat;
            attachment.offsetMatrix = offsetMatrix;
        });
    }
}